const UK_RISK_SUMMARY_URL =
  'https://www.bitpanda.com/en-gb/legal/uk-risk-summary';

export { UK_RISK_SUMMARY_URL };

const BITPANDA_ACADEMY_LINK = 'https://www.bitpanda.com/en/academy';

export { BITPANDA_ACADEMY_LINK };
